import React, { useState, useEffect } from "react";
import {
  Modal,
  Table,
  Button,
  Form,
  Input,
  Upload,
  message,
  Image,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { binaryContentsHooks as cHooks } from "../hooks";

const ContentGroupModal = ({ visible, onClose }) => {
  const [groupList, setGroupList] = useState([]); // 그룹 리스트
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [thumbnailBase64, setThumbnailBase64] = useState(null); // Base64 이미지 저장
  const [backgroundBase64, setBackgroundBase64] = useState(null);
  // 그룹 목록 불러오기
  const fetchGroups = async () => {
    setLoading(true);
    try {
      const res = await cHooks.contentsGroupList();
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setGroupList(data);
    } catch (error) {
      message.error("그룹 목록 불러오기 실패!");
      setGroupList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible) fetchGroups();
  }, [visible]);

  // 그룹 생성 핸들러
  const handleCreateGroup = async (values) => {
    try {
      if (!thumbnailBase64) {
        message.error("썸네일을 업로드하세요.");
        return;
      }
      if (!backgroundBase64) {
        message.error("백그라운드 이미지를 업로드하세요.");
        return;
      }

      const payload = {
        ...values,
        group_thumbnail: thumbnailBase64.split(",")[1], // Base64 변환된 이미지 추가
        group_background: backgroundBase64.split(",")[1],
      };
      const res = await cHooks.contentsGroupCreate({
        contentGroupName: payload.content_group_name,
        groupTag: payload.group_tag,
        groupThumbnail: payload.group_thumbnail,
        groupBackground: payload.group_background,
      });
      if (res.IsError) throw new Error();
      message.success("그룹이 생성되었습니다.");
      fetchGroups();
      form.resetFields();
      setThumbnailBase64(null); // 썸네일 초기화
    } catch (error) {
      message.error("그룹 생성에 실패했습니다.");
    }
  };

  // 이미지 업로드 시 Base64로 변환
  const handleBeforeUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setThumbnailBase64(e.target.result); // Base64 값 설정
    };
    reader.readAsDataURL(file);
    return false; // 업로드 방지
  };

  const handleBeforeUpload2 = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setBackgroundBase64(e.target.result); // Base64 값 설정
    };
    reader.readAsDataURL(file);
    return false; // 업로드 방지
  };

  const columns = [
    {
      title: "그룹 이름",
      dataIndex: "content_group_name",
    },
    {
      title: "썸네일",
      dataIndex: "group_thumbnail",
      render: (url) => <Image src={url} alt="썸네일" width={50} />,
    },
    {
      title: "백그라운드",
      dataIndex: "group_background",
      render: (url) => <Image src={url} alt="썸네일" width={50} />,
    },
    {
      title: "태그",
      dataIndex: "group_tag",
    },
  ];

  return (
    <Modal
      title="컨텐츠 그룹 불러오기"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={700}
    >
      {/* 그룹 생성 폼 */}
      <Form form={form} layout="vertical" onFinish={handleCreateGroup}>
        <Form.Item
          name="content_group_name"
          label="그룹 이름"
          rules={[{ required: true, message: "그룹 이름을 입력하세요." }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item
          label="썸네일"
          rules={[{ required: true, message: "썸네일을 업로드하세요." }]}
        >
          <Upload
            beforeUpload={handleBeforeUpload}
            listType="picture"
            showUploadList={true}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>썸네일 업로드</Button>
          </Upload>
          {thumbnailBase64 && (
            <img
              src={thumbnailBase64}
              alt="미리보기"
              style={{ width: "100px", marginTop: "10px" }}
            />
          )}
        </Form.Item>
        <Form.Item
          label="백그라운드"
          rules={[
            { required: true, message: "백그라운드 이미지를를 업로드하세요." },
          ]}
        >
          <Upload
            beforeUpload={handleBeforeUpload2}
            listType="picture"
            showUploadList={true}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>백그라운드 업로드</Button>
          </Upload>
          {backgroundBase64 && (
            <img
              src={backgroundBase64}
              alt="미리보기"
              style={{ width: "100px", marginTop: "10px" }}
            />
          )}
        </Form.Item>
        <Form.Item
          name="group_tag"
          label="태그"
          rules={[{ required: true, message: "태그를 입력하세요." }]}
        >
          <Input placeholder="태그 입력 (예: 여성건강, 수면)" />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          그룹 등록
        </Button>
      </Form>

      {/* 그룹 목록 테이블 */}
      <Table
        columns={columns}
        dataSource={groupList}
        rowKey="id"
        loading={loading}
        style={{ marginTop: 20 }}
      />
    </Modal>
  );
};

export default ContentGroupModal;
